<template>
  <tw-dialog caption="申请演示" :validate="validate" @clickCancel="clickCancel_e8e7e69f_ea5d" @clickConfirm="clickConfirm_a81c747c_961c">
    <tw-form-view v-model:data_source="apply_for_trial" :xl_span="12" :md_span="12" :lg_span="12" @btnClick="btnClick_86270a70_d4ae" style="width:350px">
    </tw-form-view>
  </tw-dialog>
</template>

<script>
import { onMounted, toRefs } from 'vue'
import { useRoute } from 'vue-router'
import apply_for_trial_controller from './apply_for_trial.controller'

export default {
    props: {
        resolve: { type: Function },
        reject: { type: Function },
        params: { type: Object }
    },
    setup(props, context) {
        const route = useRoute()
        const controller = new apply_for_trial_controller(props, context, route)

        onMounted(() => {
            try {
                if (controller.onMounted) {
                    controller.onMounted()
                }
            } catch (error) {
                console.log(error)
            }
        })

        const result = {
            apply_for_trial: controller.apply_for_trial,
            visible: controller.visible,
            resolve: controller.resolve,
            reject: controller.reject,
            params: controller.params,
            validate: (...args) => controller.validate(...args),
            applyForTrial: (...args) => controller.applyForTrial(...args),
            sendCheckCode: (...args) => controller.sendCheckCode(...args),
            clickCancel_e8e7e69f_ea5d: (...args) => controller.clickCancel_e8e7e69f_ea5d(...args),
            clickConfirm_a81c747c_961c: (...args) => controller.clickConfirm_a81c747c_961c(...args),
            btnClick_86270a70_d4ae: (...args) => controller.btnClick_86270a70_d4ae(...args)
        }

        return {
            ...toRefs(result)
        }
    }
}
</script>